import * as ACTIONS from '@/store/constants/actions.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { getClients } from '@/generated/console.js';

export const actions = {
    [ACTIONS.GET_CLIENTS]({ commit }) {
        return getClients().then((response) => {
            const clients = mapClientFields(response.clients);

            clients.forEach((client) => {
                // replace the sites with their uuid
                client.sites = client.sites.map((site) => {
                    // store each site detail before replacing the array
                    commit(MUTATIONS.SET_SITE, mapSiteFields(site, client.uuid));
                    return site.uuid;
                });

                commit(MUTATIONS.SET_CLIENT, { client });
            });

            return clients;
        });
    },
};

export function mapClientFields(clients) {
    return clients.map((client) => {
        const details = {
            client_uuid: client.uuid,
            uuid: client.uuid,
            name: client.name,
            description: client.description,
            section_type: client.section_type,
            sites: client.children, // on this first pass, just rename the attribute
        };

        return details;
    });
}

export function mapSiteFields(site, client_uuid) {
    const details = {
        client_uuid,
        uuid: site.uuid,
        name: site.name,
        description: site.description,
        section_type: site.section_type,
        sections: mapSectionsRecursively(site, site.uuid, 0),
    };

    return details;
}

// TCM-979 & TCM-1136: display all nested sections as a flat level list
// TODO: once a better dropdown component is implemented this could be updated to use option groups instead.
function mapSectionsRecursively(site, parent_uuid, level) {
    const children = site.children;
    let sections = [];

    for (let i = 0; i < children.length; i++) {
        const section = children[i];

        sections[sections.length] = {
            uuid: section.uuid,
            name: section.name,
            description: section.description,
            parent_uuid,
            level, // level of the section within the subsection tree
        };

        sections = sections.concat(mapSectionsRecursively(section, section.uuid, level + 1));
    }

    return sections;
}
